import { render } from "./QuestionField.vue?vue&type=template&id=7fa8b4c3&scoped=true"
import script from "./QuestionField.vue?vue&type=script&lang=js"
export * from "./QuestionField.vue?vue&type=script&lang=js"

import "./QuestionField.vue?vue&type=style&index=0&id=7fa8b4c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa8b4c3"]])

export default __exports__